import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.MatrixPopupContent.RuleNameCell', {
    rename: 'Rename',
    removeRuleTitle: 'Remove this rule block',
    removeRule: 'Remove rule',
});
